import React, { useState, useEffect, useRef } from 'react';
import IconCollection from '../IconCollection/IconCollection';
import NamedLink from '../NamedLink/NamedLink';
import classNames from 'classnames';
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import Avatar from '../Avatar/Avatar';
import css from './MobileBottomNavbar.module.css';


const MobileBottomNavbar = ({ setScrolling = () => { } }) => {
    const [isVisible, setIsVisible] = useState(true);
    const scrollTimeoutRef = useRef(null);
    const isScrollingRef = useRef(false);
    const state = useSelector(state => state);
    const location = useLocation();

    const { user, cart, auth } = state;
    const { currentUser, currentUserNotificationCount } = user;
    const { isAuthenticated } = auth;
    const itemsCount = cart.itemsCount || 0;

    const isLoggedIn = isAuthenticated && currentUser?.id;

    const controlNavbar = () => {
        if (!isScrollingRef.current) {
            isScrollingRef.current = true;
            setScrolling(true);
        }

        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        setIsVisible(false);

        scrollTimeoutRef.current = setTimeout(() => {
            isScrollingRef.current = false;
            setScrolling(false);
            setIsVisible(true);
        }, 150);
    };

    useEffect(() => {
        window.addEventListener('scroll', controlNavbar, { passive: true });
        return () => {
            window.removeEventListener('scroll', controlNavbar);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);

    return (
        <div id='mobileBottomNavbar' className={classNames(css.navbar, isVisible ? css.visible : css.hidden)}>
            <NamedLink className={classNames(css.navItem)} name="LandingPage">
                <div className={css.iconWrapper}><IconCollection name="homeIcon" /></div>
                <div className={css.navLink}>Home</div>
            </NamedLink>
            <NamedLink className={classNames(css.navItem, location?.pathname.includes("/listing") && css.active)} name="NewListingPage" to={{ search: '?mobilemenu=open' }}>
                <div className={css.iconWrapper}><IconCollection name="createListing" /></div>
                <div className={css.navLink}>Add Listing </div>
            </NamedLink>
            {isLoggedIn
                ? (<>
                    <NamedLink className={classNames(css.navItem, location?.pathname.includes("/cart") && css.active)} name="CartPage">
                        <div className={classNames(css.iconWrapper, css.messageIcon)}>
                            <IconCollection name="cart" />
                            {itemsCount > 0 && <span className={css.notificationBadge}>{itemsCount}</span>}
                        </div>
                        <div className={css.navLink}>Cart</div>
                    </NamedLink>
                    <NamedLink className={classNames(css.navItem, location?.pathname.includes("/inbox") && css.active)} name="InboxBasePage">
                        <div className={classNames(css.iconWrapper, css.messageIcon)}>
                            <IconCollection name="myBooking" />
                            {currentUserNotificationCount > 0 && <span className={css.notificationBadge}>{currentUserNotificationCount}</span>}
                        </div>
                        <div className={css.navLink}>Inbox</div>
                    </NamedLink>
                </>)
                : (<NamedLink className={classNames(css.navItem, location?.pathname.includes("/page/about") && css.active)} name="CMSPage" params={{ pageId: 'about' }}>
                    <div className={classNames(css.iconWrapper, css.messageIcon)}><IconCollection name="aboutUs" /></div>
                    <div className={css.navLink}>About Us</div>
                </NamedLink>)}
            {isLoggedIn ? (
                <div className={classNames(css.navItem, css.avatarWrapper)}>
                    <Avatar
                        className={css.avatar}
                        user={currentUser}
                    />
                    <span className={css.storeName}>My Store</span>
                </div>
            ) : (
                <NamedLink className={classNames(css.navItem, location?.pathname.includes("/signup") && css.active)} name="SignupPage" to={{ search: '?mobilemenu=open' }}>
                    <div className={css.iconWrapper}><IconCollection name="JOIN_NOW" /></div>
                    <div className={css.navLink}>Join</div>
                </NamedLink>
            )}
        </div>
    );
};

export default MobileBottomNavbar;